@if (adDetails.adStatus === AdStatus.Active && !!adDetails.buyerOffer) {
  <div class="shadow border rounded-3 bg-white">
    <header class="p-3 rounded-top-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
      <i class="me-2 fa-solid fa-repeat" aria-hidden="true"></i>
      <h6 class="m-0">Изпратено предложение</h6>
    </header>
    <main class="p-3">
      <p class="mb-1">
        Изпратихте предложение в размер на
        <span class="fw-medium">{{ adDetails.buyerOffer.offeredPrice.toFixed(2) }}</span>
        лева към продавача.
      </p>
      @if (!!adDetails.buyerOffer.offerMessage) {
        <p class="mb-1">
          Съобщение: <span class="fst-italic">"{{ adDetails.buyerOffer.offerMessage }}"</span>
        </p>
      }
      <p class="mb-1 small text-muted">
        Всяко предложение е валидно 72 часа, след което се анулира автоматично.
      </p>
      <p class="m-0 text-muted small text-end">
        {{ adDetails.buyerOffer.createdOn | date: 'dd.MM.yyyy' }} г.
        {{ adDetails.buyerOffer.createdOn | date: 'HH:mm' }} ч.
      </p>
      @if (adDetails.buyerOffer.status === AdOfferStatus.Rejected) {
        <hr/>
        <p class="mb-1">
          Продавачът отказа вашето предложение.
        </p>
        <p class="m-0 text-muted small text-end">
          {{ adDetails.buyerOffer.rejectedOn | date: 'dd.MM.yyyy' }} г.
          {{ adDetails.buyerOffer.rejectedOn | date: 'HH:mm' }} ч.
        </p>
      }
      @if (adDetails.buyerOffer.status === AdOfferStatus.Countered) {
        <hr/>
        <p class="mb-1">
          Продавачът изпрати контрапредложение в размер на
          <span class="fw-medium">{{ adDetails.buyerOffer.counterOfferPrice?.toFixed(2) }}</span> лева.
        </p>
        @if (!!adDetails.buyerOffer.counterOfferMessage) {
          <p class="mb-1">
            Съобщение: <span class="fst-italic">"{{ adDetails.buyerOffer.counterOfferMessage }}"</span>
          </p>
        }
        <p class="m-0 text-muted small text-end">
          {{ adDetails.buyerOffer.counteredOn | date: 'dd.MM.yyyy' }} г.
          {{ adDetails.buyerOffer.counteredOn | date: 'HH:mm' }} ч.
        </p>
      }
    </main>
    @if (adDetails.buyerOffer.status === AdOfferStatus.Countered) {
      <footer class="p-3 bg-light rounded-bottom-3 border-top">
        <div class="row g-3 justify-content-end">
          <div class="col-12 col-md-auto d-flex justify-content-end gap-3 flex-column flex-md-row">
            <button class="btn btn-success btn-sm"
                    (click)="showAdCounterOfferAcceptWarning()">
              <i class="fa-solid fa-check me-1"></i>
              Приеми
            </button>
            <button class="btn btn-danger btn-sm"
                    (click)="showAdCounterOfferRejectWarning()">
              <i class="fa-solid fa-xmark me-1"></i>
              Откажи
            </button>
          </div>
        </div>
      </footer>
    }
  </div>
}
@if (adDetails.adStatus === AdStatus.Active && !!adDetails.receivedOffers) {
  @for (offer of adDetails.receivedOffers; track offer.offerId) {
    <div class="shadow border rounded-3 bg-white mb-4">
      <header class="p-3 rounded-top-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
        <i class="me-2 fa-solid fa-repeat" aria-hidden="true"></i>
        <h6 class="m-0">Предложение от {{ offer.buyerUsername }}</h6>
      </header>
      <main class="p-3">
        <p class="mb-1">
          Потребител
          <a class="btn-link fw-bold text-decoration-none"
             [routerLink]="[appRoutes.root, appRoutes.profile, offer.buyerId]">{{ offer.buyerUsername }}</a>
          изпрати предложение в размер на
          <span class="fw-medium">{{ offer.offeredPrice.toFixed(2) }}</span> лева.
        </p>
        @if (!!offer.offerMessage) {
          <p class="mb-1">
            Съобщение: <span class="fst-italic">"{{ offer.offerMessage }}"</span>
          </p>
        }
        <p class="mb-1 small text-muted">
          Предложението е валидно 72 часа, след което се анулира автоматично.
        </p>
        <p class="m-0 text-muted small text-end">
          {{ offer.createdOn | date: 'dd.MM.yyyy' }} г.
          {{ offer.createdOn | date: 'HH:mm' }} ч.
        </p>
        @if (offer.status === AdOfferStatus.Countered) {
          <hr/>
          <p class="mb-1">
            Изпратихте контрапредложение в размер на
            <span class="fw-medium">{{ offer.counterOfferPrice?.toFixed(2) }}</span>
            лева.
          </p>
          @if (!!offer.counterOfferMessage) {
            <p class="mb-1">
              Съобщение: <span class="fst-italic">"{{ offer.counterOfferMessage }}"</span>
            </p>
          }
          <p class="m-0 text-muted small text-end">
            {{ offer.counteredOn | date: 'dd.MM.yyyy' }} г.
            {{ offer.counteredOn | date: 'HH:mm' }} ч.
          </p>
        }
      </main>
      @if (offer.status === AdOfferStatus.Pending) {
        <footer class="p-3 bg-light border-top rounded-bottom-3">
          <div class="row g-3 justify-content-end">
            <div class="col-12 col-md-auto d-flex justify-content-end gap-3 flex-column flex-md-row">
              <button class="btn btn-success btn-sm"
                      (click)="showAdOfferAcceptWarning(offer)">
                <i class="fa-solid fa-check me-1"></i>
                Приеми
              </button>
              <button class="btn btn-danger btn-sm"
                      (click)="showAdOfferRejectWarning(offer)">
                <i class="fa-solid fa-xmark me-1"></i>
                Откажи
              </button>
              <button class="btn btn-nz-primary btn-sm"
                      (click)="onOpenAdCounterOfferModal(offer)">
                <i class="fa-solid fa-repeat me-1"></i>
                Контрапредложение
              </button>
            </div>
          </div>
        </footer>
      }
    </div>
  }
}
